var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("外部订单")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "nav" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "待发货", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "待签收", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "已签收", name: "3" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                inline: true,
                model: _vm.queryForm,
                "label-width": "",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "信息" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户手机号码/姓名" },
                    model: {
                      value: _vm.queryForm.info,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "info", $$v)
                      },
                      expression: "queryForm.info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "btns" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "success", size: "small" },
              on: {
                click: function ($event) {
                  _vm.leadingInLive = true
                },
              },
            },
            [_vm._v("导入单号")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "vxe-table",
            {
              ref: "xtable",
              staticClass: "xtable",
              attrs: {
                data: _vm.tableData.list,
                "expand-config": { expandAll: true },
                "sort-config": { trigger: "cell" },
                align: "center",
              },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "seq", title: "序号", width: "55" },
              }),
              _c("vxe-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.tosee(row)
                              },
                            },
                          },
                          [
                            !_vm.is_null(row.orderCommodityList)
                              ? _c(
                                  "el-form",
                                  { staticClass: "demo-table-expand" },
                                  [
                                    _c(
                                      "el-form-item",
                                      _vm._l(
                                        row.orderCommodityList,
                                        function (items) {
                                          return _c("p", { key: items.id }, [
                                            _c("span", [
                                              _vm._v(_vm._s(items.name)),
                                            ]),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(items.price) +
                                                  " × " +
                                                  _vm._s(items.number) +
                                                  " = " +
                                                  _vm._s(items.total) +
                                                  " 元"
                                              ),
                                            ]),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                    !_vm.is_null(row.orderComplimentaryList)
                                      ? _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("附属品：")]
                                            ),
                                            _vm._l(
                                              row.orderComplimentaryList,
                                              function (items) {
                                                return _c(
                                                  "p",
                                                  {
                                                    key: items.id,
                                                    staticClass:
                                                      "complimentary",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          items.complimentaryName
                                                        )
                                                      ),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(items.price) +
                                                          " × " +
                                                          _vm._s(items.number) +
                                                          " = " +
                                                          _vm._s(items.total) +
                                                          " 元"
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "note" }, [
                              _vm.is_null(row.orderUser.comment)
                                ? _c("p", [
                                    _c("span", [_vm._v("备注：")]),
                                    _vm._v("无 "),
                                  ])
                                : _c("p", [
                                    _c("span", [_vm._v("备注：")]),
                                    _vm._v(_vm._s(row.orderUser.comment)),
                                  ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "订单编号", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "单击复制",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyButton(props.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(props.row.orderUser.orderIdStr) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "客户", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "p",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.tosee(props.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(props.row.orderUser.customerUserName) +
                                " "
                            ),
                          ]
                        ),
                        _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(props.row.orderUser.customerUserPhone) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "订单状态", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(
                                !_vm.orderTypeSelf[
                                  props.row.orderUser.orderType
                                ]
                                  ? props.row.orderUser.orderType
                                  : _vm.orderTypeSelf[
                                      props.row.orderUser.orderType
                                    ]
                              ) +
                              " "
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "销售：" + _vm._s(props.row.orderUser.employeeName)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "金额", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("p", [
                          _vm._v(
                            "总价：￥" + _vm._s(props.row.orderUser.total)
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "已收：￥" +
                              _vm._s(props.row.orderUser.receivedMoney)
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "代收：￥" +
                              _vm._s(props.row.orderUser.awaitIncomeMoney)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "收货地址", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("p", [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("收货人:"),
                          ]),
                          _vm._v(_vm._s(props.row.orderUser.addressName) + " "),
                        ]),
                        _c("p", [_vm._v(_vm._s(props.row.orderUser.address))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.activeName == "5" || _vm.activeName == "6"
                ? _c("vxe-table-column", {
                    attrs: { title: "物流订单号", "min-width": "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              props.row.orderUser.logisticsOrder.logisticsCompany.indexOf(
                                "顺丰"
                              ) == -1
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "left",
                                        width: "350",
                                        "open-delay": 200,
                                        trigger: "hover",
                                      },
                                      on: {
                                        show: function ($event) {
                                          return _vm.loginsIdClick(
                                            props.row.orderUser.logisticsOrder
                                              .parcelNumber
                                          )
                                        },
                                        hide: function ($event) {
                                          return _vm.loginsIdHide(
                                            props.row.orderUser.logisticsOrder
                                              .parcelNumber
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("iframe", {
                                        attrs: {
                                          src:
                                            "https://m.kuaidi100.com/result.jsp?nu=" +
                                            props.row.orderUser.logisticsOrder
                                              .parcelNumber,
                                          width: "100%",
                                          height: "500",
                                          frameborder: "1",
                                          scrolling: "auto",
                                          id: props.row.orderUser
                                            .logisticsOrder,
                                          name: "iframename",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          !_vm.is_null(
                                            props.row.orderUser.logisticsOrder
                                          )
                                            ? _c("p", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.orderUser
                                                        .logisticsOrder
                                                        .logisticsCompany
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm._e(),
                                          !_vm.is_null(
                                            props.row.orderUser.logisticsOrder
                                          )
                                            ? _c("p", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.orderUser
                                                        .logisticsOrder
                                                        .parcelNumber
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm.is_null(
                                            props.row.orderUser.logisticsOrder
                                          )
                                            ? _c("p", [_vm._v(" -- ")])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              props.row.orderUser.logisticsOrder.logisticsCompany.indexOf(
                                "顺丰"
                              ) != -1
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "left",
                                        width: "800",
                                        "open-delay": 200,
                                        trigger: "hover",
                                      },
                                      on: {
                                        show: function ($event) {
                                          return _vm.loginsIdClick(
                                            props.row.orderUser.logisticsOrder
                                              .parcelNumber
                                          )
                                        },
                                        hide: function ($event) {
                                          return _vm.loginsIdHide(
                                            props.row.orderUser.logisticsOrder
                                              .parcelNumber
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.loginsId ==
                                        props.row.orderUser.logisticsOrder
                                          .parcelNumber &&
                                      props.row.orderUser.logisticsOrder &&
                                      props.row.orderUser.logisticsOrder.logisticsCompany.indexOf(
                                        "顺丰"
                                      ) != -1
                                        ? _c("iframe", {
                                            attrs: {
                                              src:
                                                "https://www.sf-express.com/cn/sc/dynamic_function/waybill/#search/bill-number/" +
                                                props.row.orderUser
                                                  .logisticsOrder.parcelNumber,
                                              width: "100%",
                                              height: "500",
                                              frameborder: "1",
                                              scrolling: "auto",
                                              id: props.row.orderUser
                                                .logisticsOrder,
                                              name: "iframename",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          !_vm.is_null(
                                            props.row.orderUser.logisticsOrder
                                          )
                                            ? _c("p", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.orderUser
                                                        .logisticsOrder
                                                        .logisticsCompany
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm._e(),
                                          !_vm.is_null(
                                            props.row.orderUser.logisticsOrder
                                          )
                                            ? _c("p", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      props.row.orderUser
                                                        .logisticsOrder
                                                        .parcelNumber
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm.is_null(
                                            props.row.orderUser.logisticsOrder
                                          )
                                            ? _c("p", [_vm._v(" -- ")])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1256539192
                    ),
                  })
                : _vm._e(),
              _c("vxe-table-column", {
                attrs: {
                  title: "下单时间",
                  width: "100",
                  field: "orderUser.createdTime",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "更新时间",
                  width: "100",
                  field: "orderUser.updatedTime",
                },
              }),
              _c("vxe-table-column", {
                attrs: { title: "操作", width: "100" },
              }),
            ],
            1
          ),
          _vm.tableData.totalNum >= 1
            ? _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage1,
                        "page-sizes": [10, 20, 50, 100, 200],
                        "page-size": _vm.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.tableData.totalNum,
                        "prev-text": "上一页",
                        "next-text": "下一页",
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.leadingIn,
            "append-to-body": true,
            title: "外部订单导入",
          },
          on: {
            "update:visible": function ($event) {
              _vm.leadingIn = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "popIn" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "#",
                    multiple: false,
                    "http-request": _vm.orderImport,
                    limit: 1,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.leadingIn = false
                      _vm.popInAxios()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.leadingIn = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }